import CardCommon from '@/pages/opinion/components/CardCommon';
import React from 'react';
import { Row } from 'tea-component';
import opencriticIcon from '@op/assets/svg/channel/opencritic.svg';
import xboxIcon from '@op/assets/svg/channel/xbox.svg';
import { useIntl } from 'umi';
import useShowBtnHooks from '@/pages/opinion/hooks/useShowBtnHooks';
import './index.scss';
import './console.scss';
import PlatformTitle from '@/pages/opinion/widgets/GameStorePlate/components/PlatformTitle';
import OpenCriticScoreTrendBox from './OpenCriticScoreTrendBox';
import MetacriticScoreTrendBox from './MetacriticScoreTrendBox';
import useGetPcConsoleTimeline from '../../hooks/useGetPcConsoleTimeline';
export default function ScoreTrendsConsole({
  filter,
  gameInfo,
  apiErr,
  channel,
}: any) {
  const { formatMessage } = useIntl();

  const {
    userScoreTrendsLoading: loading,
    userScoreTrendsApiError,
    globalTrendsTimeline: timeline,
  } = useGetPcConsoleTimeline({
    keepParams: filter,
    channel: channel,
  });

  const { isShowBtn, cardListRef, showMore, clickShowMore } = useShowBtnHooks({
    loading,
    minHeight: 340,
  });

  return (
    <CardCommon
      loading={loading}
      loadingHeight={350}
      className={`score-trends-pc-console-wrapper dbo-console dbo-scoretrendbox ${
        showMore ? 'show-all' : ''
      } dbo-scoretrendbox--2`}
      title={formatMessage({ id: 'Score Trends' })}
    >
      <>
        <Row ref={cardListRef} className="dbo-scoretrendbox-row">
          <div className="dbo-scorebox">
            <PlatformTitle
              channelName="metacritic"
              title="Metacritic"
              iconTextMargin={6}
              size={16}
              className="channel-title-box"
            ></PlatformTitle>
            <MetacriticScoreTrendBox
              platformData={timeline?.metacritic}
              filterParams={filter}
            ></MetacriticScoreTrendBox>
          </div>

          <div className="dbo-scorebox">
            <PlatformTitle
              channelName="opencritic"
              title="OpenCritic"
              iconTextMargin={6}
              size={16}
              className="channel-title-box"
            ></PlatformTitle>
            <OpenCriticScoreTrendBox
              platformData={timeline?.opencritic}
              filterParams={filter}
            ></OpenCriticScoreTrendBox>
          </div>
        </Row>
      </>
    </CardCommon>
  );
}
